import { useQuery } from '@tanstack/react-query';
import supabase from '../utils/supabase';

export default function useTaskLists(id) {
  return useQuery({
    queryKey: ['taskLists', id],
    queryFn: async () => {
      let query = supabase.from('taskLists').select('*');

      const { data, error } = await query.order('created_at', {
        ascending: false,
      });
      if (error) throw error;
      return data;
    },
  });
}
